// Utilities
const tinySlider = (slider, options) => {
  document.querySelectorAll(`[data-slider="${slider}"]`).forEach(sliderEl => {
    const prevButton = sliderEl.dataset.prevButton || slider;
    const nextButton = sliderEl.dataset.nextButton || slider;
    options.container = sliderEl;
    options.prevButton = `[data-slider-prev="${prevButton}"]`;
    options.nextButton = `[data-slider-next="${nextButton}"]`;
    tns(options);
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function _throttle(cb, delay = 250) {
  let shouldWait = false
  return (...args) => {
    if (shouldWait) return
    cb(...args)
    shouldWait = true
    setTimeout(() => {
      shouldWait = false
    }, delay)
  }
}

function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
	const results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function scrollLock() {
  document.body.classList.add('no-scroll');
}

function scrollUnlock() {
  document.body.classList.remove('no-scroll');
}

function scrollToggle() {
  document.body.classList.toggle('no-scroll');
}

function hideMobileMenu() {
  mobileMenu.classList.remove('active');
  scrollUnlock();
}

function toggleMobileMenu() {
  mobileMenu.classList.toggle('active');
  scrollToggle();
  if (mobileMenu.classList.contains('active')) {
    mobilemenuBtnClose.focus();
  }
}

// Mobile Menu
const mobileMenu = document.querySelector('[data-mobile-menu]');
const mobilemenuBtn = document.querySelector('[data-mobile-menu-btn]');
const mobilemenuBtnClose = document.querySelector('[data-close-mobile-menu-btn]');

if (mobileMenu) {
  const lastFocusableElement = mobileMenu.querySelector('nav > ul > li:last-of-type > *');
  mobileMenu.addEventListener('keydown', function(e) {
    if (e.target == mobilemenuBtnClose && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastFocusableElement.focus();
    } else if (e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      mobilemenuBtnClose.focus();
    }
  });
}

if (mobilemenuBtn) {
  mobilemenuBtn.addEventListener('click',() => {
    toggleMobileMenu();
  });
}

if (mobilemenuBtnClose) {
  mobilemenuBtnClose.addEventListener('click',() => {
    hideMobileMenu();
  });
}

// Overlay
const overlay = document.querySelector('[data-overlay]');
if (overlay) {
  overlay.addEventListener('click',() => {
    hideCart();
    hideMobileMenu();
    hideDialog();
    hidePopovers();
  });
}

// Dropdowns
document.querySelectorAll('[data-dropdown-btn]').forEach(btn => {
  btn.addEventListener('click',() => {
    btn.classList.toggle('active');
  })
});

// Videos
const videos = document.querySelectorAll('[data-video]');
const vimeoVideo = document.querySelectorAll('[data-vimeo-video]');

if (videos) {
  videos.forEach(video => {
    video.addEventListener('click',() => {
      const videoEl = video.querySelector('video');
      if (videoEl.paused) {
        videoEl.play();
      } else {
        videoEl.pause();
      }
      video.classList.toggle('playing');
    })
  });
}

vimeoVideo.forEach(video => {
  const videoIframe = video.querySelector('iframe');
  const player = new Vimeo.Player(videoIframe);
  player.on('play',(event) => {
    video.classList.add('playing');
    console.log('play', true);
  });
  player.on('pause',(event) => {
    video.classList.remove('playing');
  });
});

// Footer
const currencyForm = document.getElementById('localization_form');
const currencySelect = document.querySelector('[data-currency-select]');
if (currencyForm) {
  currencySelect.addEventListener('change', event => {
    currencyForm.submit();
  });
}

// Dialog
const dialog = document.querySelector('[data-dialog]');
const entry = document.querySelector('[data-dialog-entry]');

function showDialog(btn, size) {
  dialog.classList.add('active', size);
  overlay.classList.add('active');
  setTimeout(function() {
    dialog.focus();
  }, 100);
  if (btn) window.focusResetEl = btn;
}

function hideDialog() {
  document.querySelectorAll('[data-dialog]').forEach(el => el.classList.remove('active', 'small', 'medium', 'large'));
  overlay.classList.remove('active');
  if (window.focusResetEl) window.focusResetEl.focus();
}

function insertDialogContent(html) {
  entry.innerHTML = html;
}

document.addEventListener('click', (event) => {
  if (event.target.hasAttribute('data-close-dialog')) {
    hideDialog()
  }
});

// Promo banner
(function initPromoBanner() {

  if (!window.stix_api.customer.b2b && window.stix_api.theme.promoBanner.enabled && sessionStorage.getItem('stix_hide_promo_banner') !== 'true') {
    document.body.classList.add('promo-banner-active');

    document.querySelector('[data-close-banner]').addEventListener('click',event => {
      document.body.classList.remove('promo-banner-active');
      sessionStorage.setItem('stix_hide_promo_banner', 'true');
      event.stopPropagation();
    });
  }

})();

// Personalization

(function personalize() {

const cookieName = '_p_utm_campaign';
const campaign = Cookies.get(cookieName) || getUrlParameter('utm_campaign');
const pageType = stix_api.theme.template.type;

if (!campaign) return;

fetch(`https://cdn.stix.golf/api/personalization/${campaign}`)
  .then(response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  })
  .then(json => {
    Cookies.set(cookieName, campaign, { expires: 7 });
    const promoBar = document.querySelector('[data-promo-bar]');
    if (promoBar && sessionStorage.getItem('stix_hide_promo_banner') !== 'true') {
      promoBar.style['background-color'] = json.banner_bg_color || '#e43d30';
      promoBar.style['padding-right'] = '27px';
      promoBar.style.color = json.banner_text_color || '#fff';
      const avatar = json.avatar ? `<img src="${json.avatar}" alt="" width="40" height="40" style="border-radius: 50%; border: 2px solid #fff; margin-right: 8px;">` : '';
      let videoBtn = '';
      if (json.youtube_video_id) {
        window.initPersonalizationVideo = () => {
          document.querySelector('[data-dialog-entry]').innerHTML = `<div class="responsive-iframe"><iframe width="560" height="315" src="https://www.youtube.com/embed/${json.youtube_video_id}" title="YouTube video player" frameborder="0" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
          showDialog();
        };
        videoBtn = `<button type="button" onClick="initPersonalizationVideo()" style="margin-left: 8px;"><svg width="25" height="17" fill="#fff" viewBox="0 0 42.1189 29.6148" xmlns="http://www.w3.org/2000/svg"><path d="M56.1718,68.6337a5.2923,5.2923,0,0,0-3.7238-3.7479C49.1634,64,35.9925,64,35.9925,64s-13.1709,0-16.4556.8858a5.2926,5.2926,0,0,0-3.7238,3.7479c-.88,3.306-.88,10.2036-.88,10.2036s0,6.8976.88,10.2036a5.2135,5.2135,0,0,0,3.7238,3.6881c3.2847.8858,16.4556.8858,16.4556.8858s13.1708,0,16.4555-.8858a5.2134,5.2134,0,0,0,3.7238-3.6881c.88-3.306.88-10.2036.88-10.2036S57.0519,71.94,56.1718,68.6337ZM31.6848,85.1V72.5748l11.0083,6.2627Z" transform="translate(-14.933 -64)"></path></svg></button>`;
      }
      const message = json.hp_message || json.message[pageType] || json.message.index;
      promoBar.insertAdjacentHTML('afterBegin', `
        ${avatar}
        <p>${message}</p>
        ${videoBtn}
      `);
      if (pageType == 'collection' && json.hero && json.pdp_title) {
        document.querySelectorAll('[data-collection-hero]').forEach(hero => {
          hero.style['background-image'] = `url(${json.hero})`;
          hero.querySelector('h1').innerText = json.collection_title;
          hero.querySelector('h1').style.color = json.collection_title_color;
        });
      }
      document.body.classList.add('promo-banner-active');
      document.querySelector('[data-close-banner]').addEventListener('click',event => {
        document.body.classList.remove('promo-banner-active');
        sessionStorage.setItem('stix_hide_promo_banner', 'true');
        Cookies.remove('_p_utm_campaign');
        ga('send', 'event', 'influencer_promo', 'close_promo');
        event.stopPropagation();
      });
    }
  })
  .catch((error) => {
    console.error('Error fetching personalization data:', error);
  });
})();

// Gift
function giftLineKey(cart) {
  const gwp = cart.items.find(item => item.properties['_gwp']);
  const key = gwp.key;
  return key;
}

function giftInCart(cart) {
  return cart.items.some(item => item.properties && item.properties['_gwp']);
}

function triggerProductInCart(cart) {
  return cart.items.some(item => item.properties && item.properties['_gwp_trigger']);
}

function hasSpecificGift(item) {
  if (item) {
    return item.properties && item.properties.hasOwnProperty('_gwp_override');
  } else {
    return false;
  }
}

function eligibleCartTotal(cart) {
  return (cart.total_price / 100) >= stix_api.theme.gwp.cartTotalMinimum;
}

async function gwpQuantityMatch(enabled, cart, b2b) {

  const triggerProducts = cart.items.filter(item => item.properties['_gwp_trigger']);
  const gwpProducts = cart.items.filter(item => item.properties['_gwp']);

  function triggerGwpInCart(triggerItem, cart) {
    return cart.items.some(item => item.properties['_gwp'] && item.properties['_gwp_id'] === triggerItem.properties['_gwp_id']);
  }

  function triggerGwpMatchesQuantity(triggerItem, cart) {
    const gwp = cart.items.find(item => item.properties['_gwp'] && item.properties['_gwp_id'] === triggerItem.properties['_gwp_id']);
    return gwp.quantity === triggerItem.quantity;
  }

  function triggerGwpKey(triggerItem, cart) {
    const gwp = cart.items.find(item => item.properties['_gwp'] && item.properties['_gwp_id'] === triggerItem.properties['_gwp_id']);
    return gwp.key;
  }

  function gwpTriggerProductInCart(gwpItem, cart) {
    return cart.items.some(item => item.properties['_gwp_trigger'] && item.properties['_gwp_id'] === gwpItem.properties['_gwp_id']);
  }

  for (const item of triggerProducts) {

    if (enabled && !triggerGwpInCart(item, cart) && !b2b) {
      const giftVariantId = Number(item.properties['_gwp_override']);
      const items = {
        items: [
          {
            id: giftVariantId,
            quantity: 1,
            properties: {
              '_gwp': true,
              '_gwp_id': item.properties['_gwp_id']
            }
          }
        ]
      };
      cartJs.addItems(items);
    } else if (enabled && triggerGwpInCart(item, cart) && !triggerGwpMatchesQuantity(item, cart) && !b2b) {
      const key = triggerGwpKey(item, cart);
      const update = {
        'id': key,
        'quantity': item.quantity
      };
      cartJs.updateItems(update);
    }
  }

  for (const item of gwpProducts) {
    if (!gwpTriggerProductInCart(item, cart) || b2b) {
      const key = item.key;
      const update = {
        'id': key,
        'quantity': 0
      };
      cartJs.updateItems(update);
    }
  }
}

function lineItemCartCheck(enabled, cart, b2b) {
  let correctGiftInCart = false;
  const lastTriggerItem = cart.items.findLast(item => item.properties && item.properties['_gwp_trigger']);
  if (hasSpecificGift(lastTriggerItem)) {
    correctGiftInCart = giftInCart(cart) && cart.items.find(item => item.properties['_gwp']).id.toString() === lastTriggerItem.properties['_gwp_override'];
  } else {
    correctGiftInCart = giftInCart(cart) && cart.items.find(item => item.properties['_gwp']).id.toString() == stix_api.theme.gwp.product.variantId;
  }
  if (b2b || (enabled && triggerProductInCart(cart) && giftInCart(cart) && !correctGiftInCart) || (!enabled && giftInCart(cart)) || (enabled && cart.item_count == 1 && giftInCart(cart)) || (enabled && !triggerProductInCart(cart) && giftInCart(cart))) {
    const key = giftLineKey(cart);
    const update = {
      'id': key,
      'quantity': 0
    };
    cartJs.updateItems(update);
  } else if (enabled && triggerProductInCart(cart) && !giftInCart(cart) && !correctGiftInCart && stix_api.theme.gwp.product.inStock) {
    let giftVariantId = '';
    if (hasSpecificGift(lastTriggerItem)) {
      giftVariantId = Number(lastTriggerItem.properties['_gwp_override']);
    } else {
      giftVariantId = stix_api.theme.gwp.product.variantId;
    }
    const items = {
      items: [
        {
          id: giftVariantId,
          quantity: 1,
          properties: {
            '_gwp': true
          }
        }
      ]
    };
    cartJs.addItems(items);
  }
}

function priceCartCheck(enabled, cart, b2b) {
  if (b2b || (!enabled && giftInCart(cart)) || (enabled && cart.item_count == 1 && giftInCart(cart)) || (enabled && !eligibleCartTotal(cart) && giftInCart(cart))) {
    const key = giftLineKey(cart);
    const update = {
      'id': key,
      'quantity': 0
    };
    cartJs.updateItems(update);
  } else if (enabled && eligibleCartTotal(cart) && !giftInCart(cart) && stix_api.theme.gwp.product.inStock) {
    const giftVariantId = stix_api.theme.gwp.product.variantId;
    const items = {
      items: [
        {
          id: giftVariantId,
          quantity: 1,
          properties: {
            '_gwp': true
          }
        }
      ]
    };
    cartJs.addItems(items);
  }
}

function initGift(enabled, cart, rule) {
  const b2b = stix_api.customer.b2b;
  if (rule === 'spend_x_get_y') {
    priceCartCheck(enabled, cart, b2b);
  } else if (rule === 'buy_x_get_y') {
    lineItemCartCheck(enabled, cart, b2b);
  } else if (rule === 'buy_x_match_y') {
    gwpQuantityMatch(enabled, cart, b2b);
  }
}

// Cart
const cartEl = document.querySelector('[data-cart]');
const cartClose = cartEl.querySelector('[data-close-cart]');
const cartBtns = document.querySelectorAll('[data-cart-btn]');
const cartSubmitBtn = document.querySelector('[data-cart-submit]');
const sectionsToRender = {
  'cart-count': '[data-cart-item-count]',
  'cart-items': '[data-cart-entry]'
};

if (cartEl) {
  const lastFocusableElement = cartSubmitBtn;
  cartEl.addEventListener('keydown', function(e) {
    if (e.target == cartClose && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastFocusableElement.focus();
    } else if (e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      cartClose.focus();
    }
  });
}

function checkFreeGift(cart) {
  initGift(stix_api.theme.gwp.enabled, cart, stix_api.theme.gwp.rule);
}

function renderCartSections(sections) {
  for (const name in sections) {
    document.querySelectorAll(sectionsToRender[name]).forEach(entry => {
      entry.innerHTML = sections[name];
    });
  }
  affirm.ui.refresh();
  cartHandlers();
}

function updateProgressBar(total) {
  const root = document.documentElement;
  setTimeout(() => {
    const diff = total / (stix_api.theme.settings.freeShippingThreshold * 100);
    root.style.setProperty(`--cart-progress`, `${diff * 100}%`);
  }, 1);
}

function showCart() {
  hideMobileMenu();
  cartEl.classList.add('active');
  overlay.classList.add('active');
  scrollLock();
  setTimeout(() => {
    document.querySelector('[data-cart-header]')?.focus();
  }, 150);
}

function hideCart() {
  cartEl.classList.remove('active');
  overlay.classList.remove('active');
  scrollUnlock();
}

function getGA4Items(items) {
  return items.map(item => {
    return {
      item_id: `${item.id}`,
      item_name: item.product_title,
      item_brand: item.vendor,
      item_category: item.product_type,
      item_variant: item.title,
      discount: item.total_discount / 100,
      price: item.price / 100,
      currency: stix_api.cart.currency,
      quantity: 1
    }
  });
}

async function updateBundleGroups(bundleGroups) {
  bundleGroups.forEach((group, i) => {
    const expectedBundleChildren = group[0].properties._bundle_children;
    const foundBundleChildren = group.length;
    if (foundBundleChildren < expectedBundleChildren) {
      group.forEach(async item => {
        const update = {
          'id': item.key,
          'quantity': 0
        };
        await cartJs.updateItems(update);
      });
    }
  });
}

function checkBundleChildren(cart) {
  const bundleChildren = cart.items.filter(item => item.properties._bundle_child);
  const bundleParents = cart.items.filter(item => item.properties._bundle_parent);
  let bundleGroups = [];
  bundleParents.map(parent => {
    const childrenOfParent = bundleChildren.filter(child => {
      return child.properties._bundle_parent_id == parent.id
     });
    if (childrenOfParent.length > 0) bundleGroups.push(childrenOfParent);
  });
  if (bundleGroups.length > 0) {
    updateBundleGroups(bundleGroups);
  }
}

function cartHandlers() {
  document.querySelectorAll('[data-cart-remove]').forEach(button => button.addEventListener('click',event => {
    const data = event.target.dataset;
    const index = data.lineKey;
    const item = {
      'item_id': data.lineSku,
      'item_name': data.lineProduct,
      'item_category': data.lineType,
      'item_brand': data.lineVendor,
      'item_variant': data.lineVariant,
      'price': Number(data.linePrice) / 100,
      'currency': stix_api.cart.currency,
    };
    const update = {
      'id': index,
      'quantity': 0
    };
    cartJs.updateItems(update, true, item);
  }));
  document.querySelectorAll('[data-update-qty]').forEach(button => button.addEventListener('click',event => {
    let item = {};
    const data = event.target.dataset;
    const qty = parseInt(data.lineNewQty);
    const index = data.lineKey;
    if (data.updateQty === 'remove') {
      item = {
        'item_id': data.lineSku,
        'item_name': data.lineProduct,
        'item_category': data.lineType,
        'item_brand': data.lineVendor,
        'item_variant': data.lineVariant,
        'price': Number(data.linePrice) / 100,
        'currency': stix_api.cart.currency,
      };
    }
    const update = {
      'id': index,
      'quantity': qty
    };
    const removed = qty === 0 ? true : false;
    cartJs.updateItems(update, removed, item);
  }));
  document.querySelectorAll('[data-close-cart]').forEach(button => button.addEventListener('click',() => hideCart()));
}

class Cart {
  constructor() {}

  render() {
    fetch(window.Shopify.routes.root + '?sections=cart-items,cart-count')
      .then(response => response.json())
      .then(sections => {
        renderCartSections(sections);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  refresh() {
    fetch(window.stix_api.routes.cart_url)
      .then(response => response.json())
      .then(data => {
        checkFreeGift(data);
        updateProgressBar(data.total_price);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  /*
    Add items:
      By variant id:
        items: [
        {
          'id': 794864053,
          'quantity': 3
        }
      ],
      sections: 'cart-count,cart-items'

      By line number:
      items: [
        {
          'line': 1,
          'quantity': 3
        }
      ],
      sections: 'cart-count,cart-items'
  */

  addItems(items, redirect_url) {
    items.sections = 'cart-count,cart-items';
    fetch(window.stix_api.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(items)
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      console.info('Add items success:',data);
      if (data.status === 422) return;
      const gaItems = getGA4Items(data.items);
      const itemPrices = data.items.map(item => item.price);
      const totalValue = itemPrices.reduce((previousValue, currentValue) => previousValue + currentValue, 0);
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
          'currency': stix_api.cart.currency,
          'value': totalValue / 100,
          'items': gaItems
        }
      });
      if (redirect_url) {
        window.location.pathname = redirect_url;
      } else {
        renderCartSections(data.sections);
        showCart();
        this.refresh();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  updateItems(update, removed, removedItem) {
    update.sections = 'cart-count,cart-items';
    fetch(window.stix_api.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(update)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Update items success:',data);
      renderCartSections(data.sections);
      showCart();
      checkFreeGift(data);
      checkBundleChildren(data);
      updateProgressBar(data.total_price);
      if (removed) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          'event': 'remove_from_cart',
          'ecommerce': {
            'currency': stix_api.cart.currency,
            'items': removedItem
          }
        });
      }
      })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

const cartJs = new Cart();

if (getUrlParameter('viewcart') === 'true') {
  showCart();
}

cartBtns.forEach(button => button.addEventListener('click',() => {
  showCart();
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    'event': 'view_cart',
    'ecommerce': {
      'currency': stix_api.cart.currency,
      'value': stix_api.cart.value,
      'items': stix_api.cart.items,
    }
  });
}));

cartHandlers();

// Document listeners
document.addEventListener('keydown', event => {
  if (event.key == 'Escape') {
    hideMobileMenu();
    hideCart();
    hideDialog();
    closeSearch();
    hidePopovers();
  }
  if (event.key == 'Enter') {
    if (event.target.dataset.desktopNavButton != undefined) {
      event.preventDefault();
      event.target.closest('[data-desktop-nav-item]').classList.toggle('active');
      event.target.setAttribute('aria-expanded', event.target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    }
  }
});

const dropDownMenu = document.querySelector('[data-desktop-nav-item]');
document.addEventListener('focusin', event => { 
  if (!dropDownMenu.contains(event.target) && dropDownMenu.classList.contains('active')) {
    dropDownMenu.classList.remove('active');
    dropDownMenu.querySelector('[data-desktop-nav-button]').setAttribute('aria-expanded', 'false');
  }
});

document.addEventListener('DOMContentLoaded',() => {
  // Load all registered sections
  Shopify.theme.sections.load('*');
});

document.addEventListener('rebuy.add', async (event) => {
  console.log("rebuy.add", event);
  cartJs.render();
  cartJs.refresh();
});

// Custom components

class PredictiveSearch extends HTMLElement {

  constructor() {
    super();
    this.input = this.querySelector('input[name="q"]');
    this.predictiveSearchResults = this.querySelector('[data-search-autocomplete]');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    // if (window.visualViewport) {
    //   visualViewport.addEventListener("resize", () => {
    //     this.resize();
    //   });
    // }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement) && window.innerWidth > 767) this.close();
    })
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`${stix_api.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,article,page&resources[limit]=6&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

}
customElements.define('predictive-search', PredictiveSearch);

const searchBtn = document.querySelectorAll('[data-search-btn]');
searchBtn.forEach(btn => btn.addEventListener('click',(event) => {
  btn.classList.toggle('active');
  if (btn.classList.contains('active')) {
    openSearch();
  } else {
    closeSearch();
  }
}));

function openSearch() {
  document.querySelector('[data-search-dropdown]').classList.add('active');
  document.querySelector('[name="q"]').focus();
}

function closeSearch() {
  searchBtn.forEach(btn => btn.classList.remove('active'));
  document.querySelector('[data-search-dropdown]').classList.remove('active');
}

class Popover extends HTMLElement {

  constructor() {
    super();
    this.trigger = this.querySelector('[data-pop-over-trigger]');
    this.popOver = this.querySelector('[data-pop-over]');
    this.overlay = document.querySelector('[data-overlay]');
    this.closeButton = this.querySelector('[data-pop-over-close]');
    this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
    this.closeButton.addEventListener('click', this.onCloseClick.bind(this));
  }

  onTriggerClick() {
    this.popOver.classList.add('active');
    this.overlay.classList.add('active');
    setTimeout(() => {
      this.popOver.focus();
    }, 100);
  }

  onCloseClick() {
    this.popOver.classList.remove('active');
    this.overlay.classList.remove('active');
    this.trigger.focus();
  }

}
customElements.define('custom-pop-over', Popover);

function hidePopovers() {
  document.querySelector('[data-pop-over].active')?.classList.remove('active');
}

// Klaviyo Subscribe
function klaviyoSubscribe(kl_list_id, kl_email, form) {
	var _learnq = _learnq || [];
	_learnq.push(['identify', { $email: kl_email }]);
	const xhr = new XMLHttpRequest();
	const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
  let params;
  if (form.children.endUser) {
    params = `g=${kl_list_id}&email=${encodeURIComponent(kl_email)}&$fields=WomensSetSegment&WomensSetSegment=${form.children.endUser.value}`;
  } else {
    params = `g=${kl_list_id}&email=${encodeURIComponent(kl_email)}`;
  }
  const successMessage = form.querySelector('[data-klaviyo-success-message]');
	xhr.open('POST', url, true);
	xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	xhr.setRequestHeader('cache-control', 'no-cache');
	xhr.onreadystatechange = function () {
		if (xhr.readyState === 4 && xhr.status === 200) {
			console.log(xhr.responseText);
      successMessage.style.display = 'block';
      form.reset();
      setTimeout(function () {
        successMessage.style.display = 'none';
      }, 3000);
		}
	};
	xhr.send(params);
};